import type { ComponentProps } from "react";
import { FilterChip } from "@volca/ui/components/ui/filter-chip";
import { Input } from "@volca/ui/components/ui/input";
import { Label } from "@volca/ui/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@volca/ui/components/ui/popover";
import { Stack } from "@volca/ui/components/ui/stack";

/**
 * A filter the owner types into, kept in the chip shape of its neighbours.
 * The chip carries the comparison, so the row still reads as a sentence:
 * "Revenue at least $500".
 */
export const FilterValue = ({
  label,
  comparison,
  display,
  value,
  type,
  onChange,
}: {
  label: string;
  /** How the typed value is compared, for example "at least". */
  comparison: string;
  /** The typed value as the owner should read it back. */
  display: string | undefined;
  value: string;
  type: ComponentProps<"input">["type"];
  onChange: (value: string) => void;
}) => {
  const id = `report-filter-${label.replaceAll(" ", "-").toLowerCase()}`;
  return (
    <Popover>
      <PopoverTrigger
        render={
          <FilterChip
            label={`${label} ${comparison}`}
            value={display}
            onClear={() => onChange("")}
          />
        }
      />
      <PopoverContent align="start" className="w-56">
        <Stack className="w-full" gap={1} align="stretch">
          <Label htmlFor={id} className="text-subtle">
            {label} {comparison}
          </Label>
          <Input
            id={id}
            type={type}
            step="any"
            value={value}
            onChange={(event) => onChange(event.target.value)}
          />
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
